var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',[(_vm.path ===  "homePage")?_c('homePage'):_vm._e(),(_vm.path ===  "fuWu")?_c('fuWu'):_vm._e(),(_vm.path ===  "cunZheng")?_c('cunZheng'):_vm._e(),(_vm.path ===  "zhuiSu")?_c('zhuiSu'):_vm._e(),(_vm.path ===  "baoHu")?_c('baoHu'):_vm._e(),(_vm.path ===  "jrhy")?_c('jrhy'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }